import { Resource } from 'src_common/common/mobx-utils/Resource';
import { observable, computed, action, makeAutoObservable } from 'mobx';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { notificationCountsItems } from 'src_server/types';
import addError from 'src/utils/error.jsx';

export class PEPState {
    @observable isOpenModal: boolean = false;
    @observable public isLoading: boolean;
    @observable private readonly data: Resource<notificationCountsItems.TResponseType>;
    @observable public xmlAccountId: number | null = null;

    constructor(private readonly trpcClient: TrpcClient) {
        this.isLoading = false;
        this.data = new Resource(async (): Promise<notificationCountsItems.TResponseType> => {
            return await trpcClient.client.notificationCounts.getNotificationCounts.query({
                perPage: 1,
                page: 1,
                channel: 'call-credit-pep-verification',
            });
        });
        makeAutoObservable(this);
    }

    @computed get totalItems(): notificationCountsItems.TSuccessResponse | null {
        const data = this.data.get();

        if (data.type === 'ready' && data.value.responseStatus === 'success') {
            return data.value.data;
        }

        return null;
    }

    @computed get list(): notificationCountsItems.TSuccessResponse {
        return this.totalItems ?? [];
    }

    public handleCheckOne = async (id: string, accountId: number): Promise<void> => {
        this.isLoading = true;

        try {
            const assignPep = await this.trpcClient.client.notificationCounts.updateNotificationCounts.mutate({
                entity: 'call-credit-pep-verification',
                action: 'assign',
                id,
            });
            const reviewPep = await this.trpcClient.client.notificationCounts.updateNotificationCounts.mutate({
                entity: 'call-credit-pep-verification',
                action: 'close',
                id,
            });

            if (assignPep.responseStatus === 'success' && reviewPep.responseStatus === 'success') {
                const now = new Date().toISOString();
                await this.trpcClient.client.accountData.patchAccountData.mutate({
                    accountId,
                    accountData: {
                        kycWatchlist: {
                            reviewDate: now,
                        },
                    },
                });
            }

            await this.data.refresh();
        } catch (error) {
            addError(`Failed to "set as visited, ${accountId}`);
        } finally {
            this.isLoading = false;
        }
    };

    @action public toggleModal = (accountId: number | null, isOpenModal: boolean): void => {
        this.xmlAccountId = accountId;
        this.isOpenModal = isOpenModal;
    };
}
